export enum NotifyMeErrors {
    Default = 'NOTIFY_ME_ERROR',
}
